<template>
  <div>
    <div class="title_text">
      <div>
        <Icon type="ios-bookmark" size="18" color="#0466dd" />
        <span class="title_text2">保险数据</span>
      </div>
      <div class="query_box"></div>
    </div>

    <div class="data_div">
      <div class="card_main">
        <Spin fix v-if="loading"></Spin>

        <div class="count_card">
          <div>
            <CountUp :end="zaizhi_list.length" :duration="4" v-font="18" />
          </div>
          <div class="count_title">当前在职</div>
        </div>
        <div class="count_card">
          <div>
            <CountUp :end="total_be_insured_list.length" :duration="4" v-font="18" />
          </div>
          <div class="count_title">在参(险种去重)</div>
        </div>
        <div class="count_card10" @click="click_count('五险', wuxian_be_insured_list)">
          <div>
            <CountUp :end="wuxian_be_insured_list.length" :duration="4" v-font="18" />
          </div>
          <div class="count_title3">五险</div>
        </div>
        <div
          class="count_card10"
          @click="click_count('单工伤', gongshang_be_insured_list)"
        >
          <div>
            <CountUp :end="gongshang_be_insured_list.length" :duration="4" v-font="18" />
          </div>
          <div class="count_title3">单工伤</div>
        </div>
        <div
          class="count_card10"
          @click="click_count('公积金', gongjijin_be_insured_list)"
        >
          <div>
            <CountUp :end="gongjijin_be_insured_list.length" :duration="4" v-font="18" />
          </div>
          <div class="count_title3">公积金</div>
        </div>
        <div
          class="count_card10"
          @click="click_count('商业险', business_be_insured_list)"
        >
          <div>
            <CountUp :end="business_be_insured_list.length" :duration="4" v-font="18" />
          </div>
          <div class="count_title3">商业险</div>
        </div>

        <div class="count_card10" @click="export_baofei_show = true">
          <span class="iconfont iconbaozhengjin"></span>
          <div class="count_title3">在职保费计算</div>
        </div>
      </div>
    </div>

    <Drawer :title="drawer_title" :closable="false" v-model="show" width="600">
      <div>
        <Table
          size="small"
          ref="table"
          :height="windowHeight - 110"
          :columns="columns"
          :data="table_data"
        ></Table>
      </div>
      <div class="export_div" @click="export_table">
        <Icon type="md-download" />导出表格
      </div>
    </Drawer>

    <Modal
      v-model="export_baofei_show"
      title="在职人员-保费计算"
      width="400"
      :footer-hide="true"
    >
      <dir>日期使用方式：例如选1月，就选1月到2月</dir>
      <div class="baofei_div">
        <div>
          <DatePicker
            type="month"
            v-model="export_baofei_start_date"
            placeholder="开始月份"
            style="width: 120px"
          />
          <span style="padding: 5px">-</span>
          <DatePicker
            type="month"
            v-model="export_baofei_end_date"
            placeholder="结果月份"
            style="width: 120px"
          />
          <Button
            style="font-size: 13px; margin-left: 10px"
            type="primary"
            @click="click_zaizhi_baofei"
            >开始计算</Button
          >
        </div>

        <Spin fix v-if="export_baofei_loading">
          <Icon type="ios-loading" size="18" class="demo-spin-icon-load"></Icon>
          <div>正在生成中，请稍等...</div>
        </Spin>
        <div class="export_down" v-if="export_baofei_object_name != ''">
          <Button @click="click_export_baofei">点击下载表格</Button>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import { http, open_new_page, get_view_file_url } from "@/utils/http.js";

export default {
  name: "insurance_data",
  data() {
    return {
      windowWidth: document.documentElement.clientWidth, //实时屏幕宽度
      windowHeight: document.documentElement.clientHeight, //实时屏幕高度
      project_id: "",
      project_name: "",
      query_date: [],

      // 总在参
      total_be_insured_list: [],
      // 总在职
      zaizhi_list: [],
      // 商业险
      business_be_insured_list: [],
      // 公积金
      gongjijin_be_insured_list: [],
      // 单工伤
      gongshang_be_insured_list: [],
      // 五险
      wuxian_be_insured_list: [],

      show: false,
      columns: [],
      table_data: [],
      drawer_title: "",

      loading: false,
      export_baofei_show: false,
      export_baofei_object_name: "",
      export_baofei_loading: false,

      export_baofei_start_date: null,
      export_baofei_end_date: null,
    };
  },

  methods() {},
  methods: {
    click_export_baofei() {
      get_view_file_url(this.export_baofei_object_name);
    },

    click_zaizhi_baofei() {
      if (this.export_baofei_start_date == null) {
        this.$Message.error("请选择开始月份");
        return;
      }
      if (this.export_baofei_end_date == null) {
        this.$Message.error("请选择结束月份");
        return;
      }

      if(this.export_baofei_start_date.getTime() >= this.export_baofei_end_date.getTime() ){
        this.$Message.error('结束月份需大于开始月份')
        return
      }

      var that = this;
      var obj = {
        zaizhi_list: this.zaizhi_list,
        project_id: this.project_id,
        start_time:this.export_baofei_start_date.getTime()/1000,
        end_time:this.export_baofei_end_date.getTime()/1000,
      };
      this.export_baofei_loading = true;
      http(
        "post",
        process.env.VUE_APP_HOST +
          "/my_project/project_detail/insurance_data/zaizhi_baofei",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.export_baofei_object_name = res.data.object_name;
            // this.$Modal.confirm({
            //   title: "提示",
            //   content: "<p>生成表格完成，是否下载？</p></p>",
            //   onOk: () => {
            //     get_view_file_url(object_name);
            //   },
            //   onCancel: () => {},
            // });
            that.export_baofei_loading = false;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
            that.export_baofei_loading = false;
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
          that.export_baofei_loading = false;
        });
    },

    click_count(title, data_list) {
      console.log(data_list);
      this.drawer_title = title + "-详情";
      this.show = true;
      this.columns = [
        {
          title: "序号",
          key: "index",
          width: 60,
        },
        {
          title: "姓名",
          key: "name",
        },
        {
          title: "身份证号",
          key: "idcard",
          width: 180,
        },
        {
          title: "在离职状态",
          key: "current_employment_status",
          width: 120,
          sortable: true,
        },
      ];
      this.table_data = data_list;
    },

    date_picker_change(e) {
      console.log(e);
      this.get_interview_data();
    },

    open(project_id, project_name) {
      this.project_id = project_id;
      this.project_name = project_name;

      this.get_insurance_data();
    },

    //保险数据
    get_insurance_data() {
      var that = this;
      var obj = {
        project_id: this.project_id,
      };
      that.loading = true;
      http(
        "post",
        process.env.VUE_APP_HOST + "/my_project/project_detail/insurance_data/cbzz_info",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.total_be_insured_list = res.data.cbzz_info.total_be_insured_list;
            that.zaizhi_list = res.data.zaizhi;
            that.wuxian_be_insured_list = res.data.cbzz_info.wuxian_be_insured_list;
            that.gongshang_be_insured_list = res.data.cbzz_info.gongshang_be_insured_list;
            that.gongjijin_be_insured_list = res.data.cbzz_info.gongjijin_be_insured_list;
            that.business_be_insured_list = res.data.cbzz_info.business_be_insured_list;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
          that.loading = false;
        })
        .catch((res) => {
          console.log(res, "请求出错");
          that.loading = false;
        });
    },

    export_table() {
      this.$refs.table.exportCsv({
        filename: "导出数据",
      });
    },
  },
};
</script>

<style scoped>
.baofei_div {
  padding-bottom: 50px;
}

.export_down {
  border: 1px solid #ccc;
  padding: 10px;
  margin-top: 10px;
  text-align: center;
}

.demo-spin-col .circular {
  width: 25px;
  height: 25px;
}
.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}
@keyframes ani-demo-spin {
  from {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.demo-spin-col {
  height: 100px;
  position: relative;
  border: 1px solid #eee;
}
.iconbaozhengjin {
  font-size: 19px;
  color: #ed2d07;
}

.export_div {
  padding-top: 5px;
  align-items: center;
  display: flex;
  font-size: 13px;
  justify-content: flex-end;
  cursor: pointer;
  color: #0466dd;
}

.ratiospan {
  font-size: 18px;
  position: absolute;
  right: 20px;
  top: 8px;
}

.title_text2 {
  font-weight: 600;
}

.export_table {
  font-size: 12px;
  color: #0466dd;
  font-weight: 300;
  margin-right: 10px;
  display: flex;
  align-items: center;
  cursor: pointer;
  letter-spacing: 1px;
}

.title_text {
  margin: 0px 10px 0 10px;
  font-size: 14px;
  color: #333;
  border-bottom: 1px solid #ddd;
  padding: 10px 10px 5px 0px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  letter-spacing: 2px;
}

.card_main {
  display: flex;
  flex-wrap: wrap;
  margin-top: 10px;
  position: relative;
}

.count_title {
  font-size: 13px;
  color: #333;
  margin-top: 5px;
}

.count_title2 {
  font-size: 13px;
  color: #fff;
  margin-top: 5px;
}

.count_title3 {
  font-size: 13px;
  margin-top: 5px;
}

.count_card {
  position: relative;
  margin: 0 10px 10px 0;
  cursor: pointer;
  padding: 5px 10px 10px 10px;
  width: 130px;
  border:1px solid #ececec;
  border-radius: 5px;
  background-color: #fff;
  text-align: center;
}

.count_card10 {
  position: relative;
  margin: 0 10px 10px 0;
  cursor: pointer;
  padding: 5px 10px 10px 10px;
  width: 130px;
  border:1px solid #b8bef7;
  border-radius: 5px;
  background-color: #fff;
  text-align: center;
}

.count_card10:hover {
  background: #0466dd;
  color:#fff;
  
}

.count_card10:hover .iconbaozhengjin {
  
  color:#fff;
  
}

.count_card2 {
  position: relative;
  margin: 0 10px 10px 0;
  cursor: pointer;
  padding: 5px 10px 10px 10px;
  width: 130px;
  border-radius: 5px;
  border:1px solid #ececec;

  color: #fff;
  background-color: rgb(89, 146, 220);
  text-align: center;
}

.count_card3 {
  position: relative;
  margin: 0 10px 10px 0;
  cursor: pointer;
  padding: 5px 10px 10px 10px;
  width: 130px;
  border-radius: 5px;
  color: #fff;
  background-color: rgb(248, 73, 47);
  text-align: center;
}

.data_div {
  padding: 10px;
  border-radius: 5px;
}

.query_box {
  display: flex;
  justify-content: flex-end;
}
</style>
